import React from "react";

const MedicineNotifier = () => {
  return <div>MedicineNotifier</div>;
};

export default MedicineNotifier;
